import React from 'react'

import { UIText } from 'bora-material-ui'

const UsersText = (props) => <UIText color="#79909b" {...props} />

export default UsersText
